module.exports = __webpack_public_path__ + "static/media/cotyBanner-desktop-1220x150@2x.26a6b2dc.jpg";